module.exports = __webpack_public_path__ + "static/media/meeple.fde6942d.png";